import React from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import BroadcastConsumer from './BroadcastConsumer';
import Dashboard from '../Dashboard/Vendor/Index';

const Home = (props) => {
  return (
    <Auxiliary>
      <BroadcastConsumer />
      <Title>Dashboard</Title>
      <Dashboard />
      <iframe width="100%" height="600px" src="https://www.youtube.com/embed/kWBztF6I6Ag" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    </Auxiliary>
  );
}

export default Home;